import { render, staticRenderFns } from "./vpd-error-dialog.vue?vue&type=template&id=2743f16b&scoped=true"
import script from "./vpd-error-dialog.vue?vue&type=script&lang=js"
export * from "./vpd-error-dialog.vue?vue&type=script&lang=js"
import style0 from "./vpd-error-dialog.vue?vue&type=style&index=0&id=2743f16b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2743f16b",
  null
  
)

export default component.exports